// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    handleActions
} from 'redux-actions';

import {
    GET_WARRANTY_INFO_DATA_SUCCESS,
    GET_WARRANTY_INFO_DATA_FAIL,
} from './actions';

export const INITIAL_WARRANTY_STATE: any = {
    information: {},
    isValid: true,

};

export type ServiceWarrantyDataType = Readonly<typeof INITIAL_WARRANTY_STATE>;

export default handleActions(
    {
        [GET_WARRANTY_INFO_DATA_SUCCESS]: (state, { payload }) => ({
            ...state,
            warranties: { ...payload },
        }),
        [GET_WARRANTY_INFO_DATA_FAIL]: (state, { payload }) => ({
            ...state,
            error: payload.response.data,
        }),
    },
    INITIAL_WARRANTY_STATE
);
